import React, { Component } from 'react';
import { modalRouter } from '../../router';

class ModalItem extends Component {
  
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.onClose = this.onClose.bind(this);
    this.state = {
      isOpen: true
    }
  }
  
  toggle() {
    // const idx = this.props.key
    // this.props.modalClose()
    this.setState({isOpen: !this.state.isOpen});
  }
  toggleAll() {
    // modalCloseAll()
  }
  
  onClose() {
    setTimeout(this.props.modalClose)
  }
  
  render() {
    const { routeKey, ...modalParams } = this.props;
    const { isOpen } = this.state;
    
    if (routeKey == null) return null
      const ModalComponent = modalRouter[routeKey];
    if (ModalComponent === undefined) return null
    
    return (
      <ModalComponent {...modalParams} onClosed={this.onClose} toggle={this.toggle} toggleAll={this.toggleAll} isOpen={isOpen} />
    )
  }
}

export default ModalItem;


// WEBPACK FOOTER //
// ./src/components/modals/ModalItem.js